import { createAction } from 'redux-actions'

const ns = 'domainAdmin/'

// Fetch domains for a company
export const getCompanyDomains = createAction(`${ns}GET_COMPANY_DOMAINS`)
export const getCompanyDomainsSuccess = createAction(`${ns}GET_COMPANY_DOMAINS_SUCCESS`)
export const getCompanyDomainsFail = createAction(`${ns}GET_COMPANY_DOMAINS_FAIL`)

// Clear the added domain (reset dialog state)
export const clearAddedDomain = createAction(`${ns}CLEAR_ADDED_DOMAIN`)

// Add a domain to a company
export const addCompanyDomain = createAction(`${ns}ADD_COMPANY_DOMAIN`)
export const addCompanyDomainSuccess = createAction(`${ns}ADD_COMPANY_DOMAIN_SUCCESS`)
export const addCompanyDomainFail = createAction(`${ns}ADD_COMPANY_DOMAIN_FAIL`)

// Remove a domain from a company
export const removeCompanyDomain = createAction(`${ns}REMOVE_COMPANY_DOMAIN`)
export const removeCompanyDomainSuccess = createAction(`${ns}REMOVE_COMPANY_DOMAIN_SUCCESS`)
export const removeCompanyDomainFail = createAction(`${ns}REMOVE_COMPANY_DOMAIN_FAIL`)

// Trigger domain verification
export const verifyCompanyDomain = createAction(`${ns}VERIFY_COMPANY_DOMAIN`)
export const verifyCompanyDomainSuccess = createAction(`${ns}VERIFY_COMPANY_DOMAIN_SUCCESS`)
export const verifyCompanyDomainFail = createAction(`${ns}VERIFY_COMPANY_DOMAIN_FAIL`)

// Get domain settings
export const getCompanyDomainSettings = createAction(`${ns}GET_COMPANY_DOMAIN_SETTINGS`)
export const getCompanyDomainSettingsSuccess = createAction(`${ns}GET_COMPANY_DOMAIN_SETTINGS_SUCCESS`)
export const getCompanyDomainSettingsFail = createAction(`${ns}GET_COMPANY_DOMAIN_SETTINGS_FAIL`)

// Update domain settings
export const updateCompanyDomainSettings = createAction(`${ns}UPDATE_COMPANY_DOMAIN_SETTINGS`)
export const updateCompanyDomainSettingsSuccess = createAction(`${ns}UPDATE_COMPANY_DOMAIN_SETTINGS_SUCCESS`)
export const updateCompanyDomainSettingsFail = createAction(`${ns}UPDATE_COMPANY_DOMAIN_SETTINGS_FAIL`)
